const entityCrudIconContext = require.context('@/assets/icons/entity-crud', false, /\.svg$/);
const entityCrudIconExists = (name) => entityCrudIconContext.keys().includes(`./${name}.svg`);

const getEntityIconPath = (syncProfile) => {
  const rawKey =
    syncProfile && syncProfile.targetCrm ? syncProfile.targetCrm.replaceAll('_', '-').toLowerCase() : 'default';
  const crmKey = entityCrudIconExists(rawKey) ? rawKey : 'default';
  return 'entity-crud/' + crmKey;
};

export { getEntityIconPath };
